import { observer, Observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import VisitCardsExpansion from 'singletons/VisitCardsExpansion'
import User from 'singletons/User'
import { useOnScreen } from 'hooks/useOnScreen'

import overrideTheme from 'theming/overrides/dashboard/visitsTab'
import PastVisitsFiltersForm from './PastVisitsFiltersForm'
import { PastVisitsListToggle } from 'components/FeatureFlag/toggles/PastVisitsListToggle'

const PastVisits = () => {
  const { provider, isMemberIdFilterFlagEnabled } = User
  const loader = useRef(null)

  const isOnScreen = useOnScreen(loader)

  const { pastVisits } = provider || {}

  const { memberId, filters, setFilters, clearFilters, canIncrementPage, incrementPage, list } = pastVisits || {}

  useEffect(() => {
    if (isOnScreen && canIncrementPage) {
      const timeout = setTimeout(() => incrementPage?.(), 250)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [canIncrementPage, incrementPage, isOnScreen])

  useEffect(() => {
    VisitCardsExpansion.collapseAll()
  }, [])

  useEffect(() => {
    if (!isMemberIdFilterFlagEnabled && memberId) {
      setFilters({ ...filters, memberId: '' })
    }
  }, [filters, isMemberIdFilterFlagEnabled, memberId, setFilters])

  if (!provider) {
    return null
  }

  return (
    <ThemeProvider theme={overrideTheme}>
      <PastVisitsListToggle
        list={list}
        header={
          <div className="flex justify-end">
            <Observer>
              {() => <PastVisitsFiltersForm currentFilters={filters} onApply={setFilters} onClear={clearFilters} />}
            </Observer>
          </div>
        }
      />
      <div ref={loader} className="h-[1px] w-full" />
    </ThemeProvider>
  )
}

export default observer(PastVisits)
